var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoviePlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15.091,
    viewBox: "0 0 21 15.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,104,245,0.03);stroke:#0068f5;}.b{fill:#0068f5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.735 -163.711)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M131.817,166.411a2.513,2.513,0,0,0-1.768-1.78c-1.56-.421-7.814-.421-7.814-.421s-6.254,0-7.814.421a2.513,2.513,0,0,0-1.768,1.78,28.293,28.293,0,0,0,0,9.69,2.513,2.513,0,0,0,1.768,1.78c1.56.421,7.814.421,7.814.421s6.254,0,7.814-.421a2.513,2.513,0,0,0,1.768-1.78,28.295,28.295,0,0,0,0-9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M303.3,267.961v-5.947l5.227,2.974Z",
    transform: "translate(-183.114 -93.731)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoviePlayer);
export default __webpack_public_path__ + "static/media/movie-player.9807d5f6d69c0620573df143f0c76bf9.svg";
export { ForwardRef as ReactComponent };